import Swiper from "swiper";

const swiper = new Swiper(".simple-image-slider-swiper", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".simple-image-slider-swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".simple-image-slider-swiper-button-next",
    prevEl: ".simple-image-slider-swiper-button-prev",
  },
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  speed: 800,
});